// Données extraites des cartes PDF de LA CARAVELLE

// Sections boissons partagées (présentes sur la Carte Restaurant et la Carte Gourmande)
const boissonsSections = [
  {
    name: "Apéritifs",
    items: [
      { name: "Verre de vin (15 cl)", price: "3,40 €" },
      { name: "Kir (12 cl)", price: "4,20 €" },
      { name: "Muscat (12 cl)", price: "4,20 €" },
      { name: "Sangria (15 cl)", price: "4,20 €" },
      { name: "Pichet de vin", price: "25 cl 5 € · 50 cl 9 € · 1 L 16 €" },
      { name: "Pichet de sangria", price: "25 cl 5,50 € · 50 cl 9,50 € · 1 L 16,50 €" },
      { name: "Ricard, pastis (2 cl)", price: "3,60 €" },
      { name: "Tomate, mauresque, perroquet", price: "3,80 €" },
      { name: "Porto rouge ou blanc", price: "4,50 €" },
      { name: "Martini blanc ou rouge", price: "4,50 €" },
      { name: "Campari (6 cl)", price: "4,50 €" },
      { name: "Suze (6 cl)", price: "4,50 €" },
      { name: "Coupe de champagne (12 cl)", price: "9 €" },
      { name: "Kir royal", price: "10 €" },
    ],
  },
  {
    name: "Bières Pression (25 cl)",
    items: [
      { name: "Pelforth", price: "3,80 €" },
      { name: "Affligem blonde", price: "4,90 €" },
      { name: "Panaché", price: "3,80 €" },
      { name: "Monaco", price: "3,80 €" },
      { name: "Picon bière", price: "4,60 €" },
      { name: "IPA Lagunitas", price: "4,90 €" },
      { name: "Desperados", price: "4,90 €" },
    ],
    footnote: "Également disponibles en 50 cl.",
  },
  {
    name: "Bières Bouteilles (33 cl)",
    items: [
      { name: "Mort Subite", price: "6 €" },
      { name: "Pelforth brune", price: "6 €" },
      { name: "Chouffe blonde", price: "6 €" },
      { name: "Chimay rouge", price: "6 €" },
      { name: "Heineken zéro", price: "6 €" },
      { name: "Desperados zéro", price: "6 €" },
    ],
  },
  {
    name: "Alcools (4 cl)",
    items: [
      { name: "Whisky Clan Campbell", price: "6,50 €" },
      { name: "Whisky JB", price: "7 €" },
      { name: "Whisky Jack Daniel's", price: "8 €" },
      { name: "Whisky Aberlour", price: "9,50 €" },
      { name: "Rhum blanc", price: "7 €" },
      { name: "Rhum ambré", price: "7,50 €" },
      { name: "Don Papa", price: "9 €" },
      { name: "Presidente", price: "9,50 €" },
      { name: "Diplomatico", price: "9,50 €" },
      { name: "Zacapa", price: "12 €" },
      { name: "Gin", price: "7,50 €" },
      { name: "Vodka", price: "7,50 €" },
      { name: "Téquila", price: "7,50 €" },
      { name: "Malibu", price: "7,50 €" },
    ],
    footnote: "Supplément soda +1 €.",
  },
  {
    name: "Digestifs (4 cl)",
    items: [
      { name: "Liqueur Cabanel (menthe, citron ou mandarine)", price: "7,50 €" },
      { name: "Baileys, Get 27, Get 31", price: "7,50 €" },
      { name: "Poire, cognac, armagnac, calvados", price: "8,50 €" },
    ],
  },
];

const vinsSections = [
  {
    name: "Vins Blancs",
    items: [
      { name: "Miramont, Domaine Alaric", price: "Btl 17 €" },
      { name: "Rolle, Combe Saint Paul", price: "Verre 4,50 € · Btl 19 €" },
      { name: "6e Sens, Gérard Bertrand", price: "Verre 4,90 € · Btl 22,90 €" },
      { name: "Sugar Baby (moelleux), Domaine Vellas", price: "Verre 4,90 € · Btl 21 €" },
      { name: "Arpège, Château Rouquette", price: "Verre 6,90 € · Btl 27 €" },
    ],
    footnote: "Verre 12,5 cl · Bouteille 75 cl.",
  },
  {
    name: "Vins Rosés",
    items: [
      { name: "Miramont, Domaine Alaric", price: "Btl 17 €" },
      { name: "6e Sens, Gérard Bertrand", price: "Verre 4,90 € · Btl 25 €" },
      { name: "Gris Blanc, Gérard Bertrand", price: "Verre 5,90 € · Btl 26 €" },
      { name: "Adagio, Château Rouquette", price: "Verre 6,90 € · Btl 27 €" },
    ],
    footnote: "Verre 12,5 cl · Bouteille 75 cl.",
  },
  {
    name: "Vins Rouges",
    items: [
      { name: "Miramont, Domaine Alaric", price: "Btl 17 €" },
      { name: "6e Sens, Gérard Bertrand", price: "Verre 4,90 € · Btl 25 €" },
      { name: "Esprit Terroir, Château Rouquette", price: "Verre 6,90 € · Btl 27 €" },
    ],
    footnote: "Verre 12,5 cl · Bouteille 75 cl.",
  },
];

export const carteRestaurant = {
  title: "Carte Restaurant",
  subtitle: "Cuisine de bord de mer, généreuse et raffinée",
  sections: [
    {
      name: "Fruits de Mer",
      items: [
        { name: "6 huîtres", price: "12 €" },
        { name: "12 huîtres", price: "22 €" },
        { name: "6 crevettes", price: "11 €" },
        { name: "12 crevettes", price: "18 €" },
        { name: "10 bulots", price: "10 €" },
        { name: "Duo bulots & crevettes", price: "16 €" },
        { name: "Plateau La Caravelle", desc: "6 huîtres, 6 bulots, 6 crevettes", price: "28 €" },
      ],
      img: "/fruits-de-mer.webp",
    },
    {
      name: "Les Entrées",
      items: [
        { name: "Ceviche de crevettes", desc: "Crevettes marinées, citron vert, avocat, oignon rouge, coriandre, mangue", price: "14 €" },
        { name: "Tomate burrata", desc: "Burrata crémeuse, pesto, salade, huile d'olive", price: "13 €" },
        { name: "Salade grecque", desc: "Salade, tomate, poivrons, oignon, féta, huile d'olive", price: "13 €" },
        { name: "Tataki de thon", desc: "Mariné à l'huile de sésame, à la sauce soja salée et au jus de citron", price: "14 €" },
        { name: "Pastilla du jour", desc: "Poulet ou fruits de mer cuisinés avec des vermicelles chinois, de la cannelle et autres épices", price: "15 €" },
      ],
      img: "/resto-entree.webp",
    },
    {
      name: "Salades Repas",
      items: [
        { name: "Salade crispy", desc: "Salade, poulet crispy, tomate, copeaux grana padano, croûtons", price: "17 €" },
        { name: "Salade burrata serrano", desc: "Salade, tomate, burrata, serrano", price: "18 €" },
        { name: "Salade La Caravelle", desc: "Salade, tomate, julienne de carotte, avocat, mangue, gambas poêlées, sauce huile d'olive, miel, citron, ciboulette et gingembre", price: "19 €" },
      ],
    },
    {
      name: "Poissons & Fruits de Mer",
      items: [
        { name: "Brochettes de tentacule de poulpe et gambas grillées", price: "26 €" },
        { name: "Poisson entier et sa sauce vierge", price: "23 €" },
        { name: "Pavé de saumon mariné à la sauce teriyaki", price: "21 €" },
        { name: "Émincé de seiches sauté aux deux poivrons", price: "19 €" },
        { name: "Thon croustillant et sa sauce aigre douce à la framboise", price: "21 €" },
        { name: "Pareillade de la mer", desc: "Poisson entier, pavé de saumon, seiche, gambas", price: "32 €" },
      ],
    },
    {
      name: "Viandes",
      items: [
        { name: "Émincé de magret de canard sauce miel et fruits", price: "23 €" },
        { name: "Entrecôte sauce poivre ou champignons", price: "24 €" },
        { name: "Poulet à l'ananas, riz, sauce aigre douce servi dans son demi-ananas", price: "21 €" },
        { name: "Tajine du jour", price: "19 €" },
      ],
      img: "/resto-viande.webp",
    },
    {
      name: "Burgers",
      items: [
        { name: "Cheese burger", desc: "Bun, steak haché 150g façon bouchère, salade, tomate, oignon, pickles cornichons, cheddar, sauce", price: "19 €" },
        { name: "Chicken burger", desc: "Bun, poulet croustillant, salade, tomate, oignon, cheddar, sauce", price: "18 €" },
        { name: "Bacon burger", desc: "Bun, steak haché 150g façon bouchère, salade, tomate, oignons caramélisés, pickles cornichons, cheddar, tranche de bacon, sauce barbecue", price: "21 €" },
      ],
    },
    {
      name: "Planches à Partager",
      items: [
        { name: "Planche ibérique", desc: "Jambon serrano, lomo, chorizo", price: "16 €" },
        { name: "Planche ibérique et fromages", desc: "Jambon serrano, lomo, chorizo, manchego, comté, confiture de figue", price: "18 €" },
        { name: "Planche asiatique", desc: "Nem, samoussa, beignets de crevettes, brochette teriyaki, sauce aigre douce", price: "19 €" },
        { name: "Planche méditerranéenne", desc: "Tzatziki, houmous, falafels, féta, pain pita", price: "19 €" },
      ],
    },
    {
      name: "Les Tapas",
      items: [
        { name: "Falafels (8 pièces)", price: "8 €" },
        { name: "Poulet croustillant", price: "9 €" },
        { name: "Nems au poulet (4 pièces)", price: "8 €" },
        { name: "Samoussas aux légumes (4 pièces)", price: "8 €" },
        { name: "Beignets de crevettes (4 pièces)", price: "8 €" },
        { name: "Accras à la morue (8 pièces)", price: "8 €" },
        { name: "Moules persillées gratinées", price: "8 €" },
        { name: "Beignets de calamars", price: "8 €" },
        { name: "Anchois infarinata", price: "8 €" },
        { name: "Tzatziki et sa pita", price: "7 €" },
        { name: "Houmous et sa pita", price: "7 €" },
      ],
    },
    {
      name: "Desserts",
      items: [
        { name: "Brioche perdue, caramel beurre salé et sa glace vanille", price: "9 €" },
        { name: "Mi-cuit au chocolat noir, cœur coulant", price: "8 €" },
        { name: "Panna cotta coco exotique", price: "8 €" },
        { name: "Chou géant, chocolat chaud et glace vanille", price: "9 €" },
        { name: "Gâteau à l'ananas, boule de glace", price: "8 €" },
        { name: "Assiette de trois fromages, confiture de figue", price: "8,5 €" },
      ],
    },
    {
      name: "Menu du Jour — 23 €",
      desc: "Entrée, plat, dessert — servi uniquement le midi",
      items: [],
      footnote: "Exemple : Entrée — Salade scandinave ou assiette de bulots sauce aïoli  •  Plat — Tajine poulet ou paupiette de poisson sauce basilic  •  Dessert — Deux boules de glace ou panna cotta coco mangue.",
    },
    ...boissonsSections,
    ...vinsSections,
  ],
};

export const cartePetitDejeuner = {
  title: "Carte Petit Déjeuner",
  subtitle: "Commencez la journée face à la mer",
  sections: [
    {
      name: "Nos Formules",
      items: [
        { name: "Formule Express", desc: "Expresso et viennoiserie", price: "3,5 €" },
        { name: "Formule Classique", desc: "Boisson chaude*, viennoiserie, verre de jus d'orange", price: "7 €" },
        { name: "Formule Complète", desc: "Boisson chaude*, viennoiserie, verre de jus d'orange et tartines beurre et confiture (ou nutella ou miel)", price: "9 €" },
      ],
      footnote: "* expresso, thé, chocolat chaud ou café crème  •  Supplément orange pressée +2€",
    },
    {
      name: "Boissons Chaudes",
      items: [
        { name: "Café / Expresso", price: "2 €" },
        { name: "Café allongé", price: "2,20 €" },
        { name: "Café noisette", price: "2,20 €" },
        { name: "Café crème", price: "3,80 €" },
        { name: "Double expresso", price: "3,80 €" },
        { name: "Cappuccino", price: "4,80 €" },
        { name: "Café viennois", price: "4,80 €" },
        { name: "Latte macchiato", price: "4,90 €" },
        { name: "Café décaféiné", price: "2,20 €" },
        { name: "Décaféiné allongé", price: "2,30 €" },
        { name: "Décaféiné noisette", price: "2,30 €" },
        { name: "Décaféiné crème", price: "3,90 €" },
        { name: "Lait chaud", price: "2,80 €" },
        { name: "Chocolat chaud", price: "3,90 €" },
        { name: "Chocolat viennois", price: "4,90 €" },
        { name: "Thé ou infusion", price: "3,80 €" },
        { name: "Café arrosé", price: "5 €" },
        { name: "Irish coffee", price: "10 €" },
        { name: "Supplément sirop (caramel, spéculoos, cookies, vanille, noisette)", price: "1 €" },
      ],
    },
    {
      name: "Matcha & Ube",
      items: [
        { name: "Latte", price: "6 €" },
        { name: "Latte glacé", price: "7 €" },
        { name: "Milkshake", price: "8,50 €" },
        { name: "UBE Latte", price: "6 €" },
        { name: "UBE Latte glacé", price: "7 €" },
        { name: "UBE Milkshake", price: "8,50 €" },
      ],
    },
    {
      name: "Jus & Pressés",
      items: [
        { name: "Jus de fruits 25 cl", desc: "Orange, fraise, tomate, pomme, ananas, abricot", price: "3,90 €" },
        { name: "Orange ou citron pressé", price: "5 €" },
        { name: "Sirop à l'eau", price: "2,80 €" },
        { name: "Oasis tropical 25 cl", price: "3,90 €" },
      ],
    },
  ],
};

export const carteGourmande = {
  title: "Carte Gourmande",
  subtitle: "Cocktails, douceurs glacées et plaisirs sucrés",
  sections: [
    {
      name: "Cocktails Alcoolisés — 9,90 €",
      items: [
        { name: "Mojito", desc: "Rhum, citron vert, menthe, eau gazeuse" },
        { name: "Cuba Libre", desc: "Rhum, coca, citron vert" },
        { name: "Planteur", desc: "Rhum, ananas, orange, citron, grenadine" },
        { name: "Piña colada", desc: "Rhum, coco, jus ananas" },
        { name: "Mai Tai", desc: "Rhum, triple sec, citron, ananas, orange, grenadine" },
        { name: "Daïquiri", desc: "Rhum, sirop canne, jus de citron" },
        { name: "Blue Lagon", desc: "Vodka, curaçao bleu, jus de citron" },
        { name: "Moscow Mule", desc: "Vodka, citron vert, ginger beer" },
        { name: "Téquila Sunrise", desc: "Téquila, jus orange, sirop de grenadine" },
        { name: "Caïpiroska", desc: "Vodka, citron vert, sucre de canne" },
        { name: "Caïpirinha", desc: "Cachaça, citron vert, sucre de canne" },
        { name: "Margarita", desc: "Téquila, Cointreau, jus citron, sucre de canne" },
        { name: "Gin Tonic", desc: "Gin, Schweppes" },
        { name: "Gin Fizz", desc: "Gin, citron, sucre de canne, limonade" },
        { name: "Ice Blue", desc: "Gin, curaçao, jus citron, sirop de canne" },
        { name: "Americano", desc: "Campari, Martini rouge et blanc, eau gazeuse" },
        { name: "Spritz", desc: "Apérol, pétillant, eau gazeuse" },
      ],
    },
    {
      name: "Mocktails — 8 €",
      items: [
        { name: "Virgin Mojito", desc: "Classique ou fruits" },
        { name: "Virgin Piña Colada" },
        { name: "Passion Tropicale", desc: "Jus de mangue, passion, goyave, sirop de grenadine" },
        { name: "Paradisio", desc: "Jus mangue, ananas, goyave, sirop fraise" },
        { name: "L'Exotique", desc: "Jus d'orange, jus ananas, citron, kiwi" },
        { name: "Waikiki", desc: "Jus orange, ananas, passion, sirop grenadine" },
      ],
    },
    {
      name: "Smoothies — 7,80 €",
      items: [
        { name: "Funny Berries" },
        { name: "Pinky Groovy" },
        { name: "Coconut Fever" },
        { name: "Yellow Slow" },
      ],
    },
    {
      name: "Milkshakes (avec chantilly)",
      items: [
        { name: "1 parfum au choix", price: "8 €" },
        { name: "Oréo, KitKat ou Lion®", price: "8,50 €" },
        { name: "Coco mangue", price: "8 €" },
        { name: "Banane chocolat", price: "8 €" },
      ],
    },
    {
      name: "Frappés & Thés Glacés",
      items: [
        { name: "Café frappé", price: "5,60 €" },
        { name: "Cappuccino frappé", price: "5,60 €" },
        { name: "Thé glacé pêche, citron, fraise ou exotique", price: "4,80 €" },
      ],
    },
    {
      name: "Crêpes & Gaufres",
      items: [
        { name: "Sucre", price: "Crêpe 4 € / Gaufre 5 €" },
        { name: "Miel", price: "Crêpe 5 € / Gaufre 6 €" },
        { name: "Nutella®", price: "Crêpe 5 € / Gaufre 6 €" },
        { name: "Sauce chocolat", price: "Crêpe 5 € / Gaufre 6 €" },
        { name: "Sauce caramel beurre salé", price: "Crêpe 5 € / Gaufre 6 €" },
      ],
    },
    {
      name: "Nos Signatures (Crêpes & Gaufres)",
      items: [
        { name: "La Bretonne", desc: "Glace caramel beurre salé, sauce caramel beurre salé, spéculoos, chantilly", price: "Crêpe 8,50 € / Gaufre 9,50 €" },
        { name: "L'Antillaise", desc: "Nutella®, banane, chantilly", price: "Crêpe 8,50 € / Gaufre 9,50 €" },
        { name: "La Fruits Rouges", desc: "Fruits rouges, coulis fruits rouges et chantilly", price: "Crêpe 8,50 € / Gaufre 9,50 €" },
        { name: "La Pistachio", desc: "Glace pistache, sauce chocolat, éclats de pistache, chantilly", price: "Crêpe 9,50 € / Gaufre 9,50 €" },
        { name: "L'Exotique", desc: "Ananas, glace coco, coulis exotique, chantilly, coco râpée", price: "Crêpe 9,50 € / Gaufre 10,50 €" },
      ],
    },
    {
      name: "Glacier — À composer",
      items: [
        { name: "1 boule", price: "3,50 €" },
        { name: "2 boules", price: "6 €" },
        { name: "3 boules", price: "8 €" },
        { name: "Chantilly", price: "1,50 €" },
        { name: "Coulis", price: "1,50 €" },
      ],
      footnote: "Glaces artisanales fabriquées dans l'Aude à Lézignan-Corbières.  Crèmes glacées : vanille, chocolat, café, pistache, coco, licorne, barbapapa, créole (rhum raisin), caramel salé, banane marbrée noisette, vanille macadamia caramel, menthe chocolat.  Sorbets : fraise, passion, fraise basilic, ananas, citron, litchi framboise, mangue, cerise, grenade, violette.",
    },
    {
      name: "Coupes Signatures — 11,90 €",
      items: [
        { name: "La Gourmande", desc: "Vanille macadamia caramel, praliné rocher, chocolat, coulis chocolat, biscuit chocolat, chantilly" },
        { name: "La Fruits Rouges", desc: "Fraise, cerise, litchi framboise, coulis fruits rouges, bonbon fraise, chantilly" },
        { name: "La Choco Menthe", desc: "1 boule coco, 2 boules menthe chocolat, coulis chocolat, biscuits chocolat, chantilly" },
        { name: "Fraise Melba", desc: "2 boules fraise, 1 boule vanille, fruits fraise, nappage fruits rouges, chantilly" },
        { name: "Banana Split", desc: "1 boule chocolat, 1 boule fraise, 1 boule vanille, banane, coulis chocolat, chantilly" },
        { name: "La Créole", desc: "2 boules rhum raisin, 1 boule café, coulis café, ananas, chantilly" },
      ],
    },
    {
      name: "Coupes Alcoolisées — 11,90 €",
      items: [
        { name: "Colonel", desc: "2 boules citron, vodka" },
        { name: "La Piña", desc: "2 boules coco, 1 boule ananas, Malibu" },
        { name: "La Mint", desc: "2 boules menthe chocolat, Get 27" },
      ],
    },
    ...boissonsSections,
    ...vinsSections,
  ],
};
